import type { CollectionModelState } from '../collection.state';
import { CollectionModelBrightnessCorrectionState } from './brightnessCorrection.state';

export type ModelStateBrightnessCorrectionTag = 'gamma';
export interface ModelStateBrightnessCorrection {
	id: string;
	tag: ModelStateBrightnessCorrectionTag;
}

export class CollectionModelBrightnessCorrectionMutator<
	T extends CollectionModelBrightnessCorrection = CollectionModelBrightnessCorrection,
> {
	brightnessCorrection: T;

	constructor(brightnessCorrection: T) {
		this.brightnessCorrection = brightnessCorrection;
	}

	setValue(state: T['state']) {
		this.brightnessCorrection.collectionState.setFieldValue(this.brightnessCorrection.instanceId, state);
	}

	/** Gives a shallow clone of the brightness correction state */
	getValue(): T['state'] {
		return Object.assign({}, this.brightnessCorrection.state);
	}

	/**
	 * Remove the state of this brightness correction
	 * *Warning:* You will need to unlink & remove the brightness correction from the list before destroying the state.
	 * @see CollectionModelBrightnessCorrectionStateMutator.remove
	 */
	destroyState() {
		this.brightnessCorrection.collectionState.setFieldValue(this.brightnessCorrection.instanceId, null);
	}

	/**
	 * Remove the brightness correction,
	 * This will unlink and destroy the brightness correction and all associated values.
	 *
	 * @see CollectionModelBrightnessCorrectionStateMutator.remove
	 */
	remove() {
		this.brightnessCorrection.brightnessCorrectionState.Mutator.remove(this.brightnessCorrection);
	}
}

export abstract class CollectionModelBrightnessCorrection<
	T extends ModelStateBrightnessCorrection = ModelStateBrightnessCorrection,
> {
	abstract tag: ModelStateBrightnessCorrectionTag;
	/** Computed id of the brightness correction */
	instanceId: string;
	id: string;
	captureId: string;
	brightnessCorrectionState: CollectionModelBrightnessCorrectionState;

	Mutator: CollectionModelBrightnessCorrectionMutator;

	constructor(state: CollectionModelBrightnessCorrectionState, brightnessCorrectionId: string, captureId: string) {
		this.instanceId = CollectionModelBrightnessCorrectionState.brightnessCorrectionId(
			captureId,
			brightnessCorrectionId
		);
		this.id = brightnessCorrectionId;
		this.captureId = captureId;
		this.brightnessCorrectionState = state;
	}

	get state(): T | null {
		return this.collectionState.getFieldValue(this.instanceId) as T;
	}

	get collectionState(): CollectionModelState {
		return this.brightnessCorrectionState.collection.state;
	}

	get isDeletable() {
		return true;
	}
}
